import { render } from "./my-header.vue?vue&type=template&id=6c98fb6a&scoped=true"
import script from "./my-header.vue?vue&type=script&lang=js"
export * from "./my-header.vue?vue&type=script&lang=js"

import "./my-header.vue?vue&type=style&index=0&id=6c98fb6a&lang=css"
import "./my-header.vue?vue&type=style&index=1&id=6c98fb6a&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c98fb6a"]])

export default __exports__